import { lazy } from 'react';
const CompetitionRoutes = [
    {
        label: '',
        key: 'CompetitionLayout',
        path: '/competition',
        redirect: 'list',
        element: lazy(() => import('@/components/Layout/CompetitionLayout')),
        children: [
            {
                label: '我的竞赛',
                key: 'list',
                path: 'list',
                show: true,
                element: lazy(() => import('@/page/Competition/List'))
            },
            {
                label: '大赛详情',
                key: 'detail',
                show: true,
                path: 'detail/:id',
                element: lazy(() => import('@/page/Competition/Detail'))
            },
            {
                label: '问卷调查',
                key: 'question-sheet',
                show: true,
                path: 'question-sheet',
                element: lazy(() => import('@/page/Competition/QuestionSheet'))
            },
            {
                label: '作品预览',
                key: 'work-preview',
                show: true,
                path: 'work-preview/:id',
                element: lazy(() => import('@/page/Competition/WorkPreview'))
            },
            {
                label:'大赛作品集展示',
                key: 'workCollectionShow',
                path: 'workCollectionShow/:id/work/:student_id',
                show: true,
                element: lazy(() => import('@/page/Competition/WorkCollection'))
            },
            {
                label: '画像',
                key: 'dataMap',
                show: true,
                path: 'dataMap/:id',
                element: lazy(() => import('@/page/Competition/DataMap'))
            },
            {
                label: '成果奖项',
                key: 'resultPrize',
                show: true,
                path: 'resultPrize/:id',
                element: lazy(() => import('@/page/Competition/ResultPrize'))
            },
            {
                label: '问卷',
                key: 'survey',
                show: true,
                path: 'survey/:id',
                element: lazy(() => import('@/page/Project/Survey/competion'))
            }
        ]
    },{
        label:'大赛作品展示',
        key: 'CompetitionWorkShow',
        path: '/public/competitionWorkShow/:id/rule/:rule_id',
        show: true,
        element: lazy(() => import('@/page/Competition/ShowWorks'))
    }
];
export default CompetitionRoutes;
